import React, { useState } from 'react';
import './InfoTooltip.css'; // We'll create this CSS file next

interface InfoTooltipProps {
  text: string; // The explanation text to show in the tooltip
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div 
      className="info-tooltip-container"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <span className="info-icon">ⓘ</span>
      {isVisible && (
        <div className="info-tooltip-text">
          {text}
        </div>
      )}
    </div>
  );
}; 